module.exports = [{"name":"חולמת לפתוח ערוץ ביוטי משלך ביוטיוב?","desc":"מוזמנת לגלות עד כמה את שולטת בעולם האיפור","link":"https://www.playbuzz.com/poweredby10/2-7-2018-12-48-25-pm","embed":"0aabcaf4-6012-4559-8f3e-ff98ad1e7763","poster":"poster.jpg","className":"makeup","sectionName":"section3"}]


//////////////////
// WEBPACK FOOTER
// ./src/api/PlayBuzz.json
// module id = 73
// module chunks = 0